import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";
import { StorageScope } from "../../../services/api/instances/storageApi/types/service_types";

export const selectUiState = (state: RootState) => state.uiState;

export const selectUi = createSelector(selectUiState, (state) => state.ui);

export const selectServiceUi = createSelector(
  [selectUi, (_: RootState, service: StorageScope) => service],
  (ui, service) => {
    return ui ? ui[service] : null;
  },
);
